import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';

import { AppLayout } from '@/layouts/AppLayout';
import { ErrorState } from '@/components/ErrorState';
import { Button } from '@/components/ui/button';
import { LlmChatDrawerProvider } from '@/components/llm-chat/llm-chat-drawer-context';

function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  return new Error(typeof error === 'string' ? error : JSON.stringify(error));
}

export function AppShellErrorRoute() {
  const { t } = useTranslation();
  const error = useRouteError();
  const parsedError = toError(error);

  useEffect(() => {
    Sentry.captureException(parsedError, {
      tags: { area: 'app-shell-route' },
    });
  }, [parsedError]);

  return (
    <LlmChatDrawerProvider>
      <AppLayout breadcrumbs={[{ href: '#', children: t('generic.error') }]}>
        <ErrorState>
          <h2>{t('error.title')}</h2>
          <p className="text-muted-foreground text-sm break-words">{parsedError.message}</p>
          <Button type="button" variant="outline" onClick={() => window.location.reload()}>
            {t('error.tryAgain')}
          </Button>
        </ErrorState>
      </AppLayout>
    </LlmChatDrawerProvider>
  );
}
